import { angular, app } from '../app.module'
app.controller(
  'AccountCtrl',
  (
    $rootScope,
    $scope,
    $state,
    $timeout,
    $filter,
    AccountService,
    localStorageService,
    SnsSelectTabService
  ) => {
    // アクセスのフラグをチェックして、フラグがない場合は、ブランドにリダイレクトする
    if ($rootScope.flgAccount === false) {
      $state.go('brand')
    }
    // フィルタリングの対象をルートスコープに保存
    $rootScope.messageFilter = null
    $rootScope.accountTagFilter = null
    $rootScope.followerFilter = null
    // md-row-select 用の選択状態
    $scope.selected = []
    $scope.selectTab = selectTab

    // SNSタブのインデックスを取得
    const tabIndex = SnsSelectTabService.getTabIndex()

    // ローカルストレージに保存されているSNSの選択状態を取得し、タブの選択処理を行う
    let selectedSns = localStorageService.get('selectedSns')

    // SNSの選択状態がローカルストレージに保存されていない場合、facebookにする
    if (selectedSns === null) {
      selectedSns = 'facebook'
    }

    // ローカルストレージに保存されていたSNSの利用許可があるかチェックしたのちに、タブの選択処理を行う
    const checkedSns = SnsSelectTabService.checkLocalTab(selectedSns)

    selectTab(checkedSns)

    /**
     * タブが選択された際の処理
     * 選択されたSNSをスコープにセットし、初期化を行う
     * @param {string} selectedSns 選択されたSNS
     */
    function selectTab(selectedSns) {
      // 同じSNSのタブの場合は、何も処理をしない
      if ($scope.selectedTab === selectedSns) {
        return
      }
      if (selectedSns !== null) {
        $scope.selectedTab = selectedSns

        switch (selectedSns) {
          case 'facebook':
            $scope.selectedTabIndex = tabIndex.facebook
            break
          case 'twitter':
            $scope.selectedTabIndex = tabIndex.twitter
            break
          case 'instagram':
            $scope.selectedTabIndex = tabIndex.instagram
            break
          case 'youtube':
            $scope.selectedTabIndex = tabIndex.youtube
            break
          case 'line':
            $scope.selectedTabIndex = tabIndex.line
            break
          case 'tiktok':
            $scope.selectedTabIndex = tabIndex.tiktok
            break
        }
      }

      if ($scope.selectedTab !== undefined) {
        // スコープの初期化
        initAccountScope()

        // ローカルストレージにSNSの選択状態を保存
        localStorageService.set('selectedSns', $scope.selectedTab)
      }
    }

    /**
     * initPostScope 投稿機能に必要なスコープを初期化
     * @return {void}
     */
    function initAccountScope() {
      // アカウント情報を表示するフラグ(アカウント情報しか表示しない)
      $scope.showAccountInfoFlg = 'account-only'
      // ロード中フラグを立てる
      $scope.isLoading = true
      // md-row-select 用の選択状態
      $scope.selected = []
      // 一括タグ追加を行う対象のIDの配列
      $scope.selectedIds = []

      // テーブルクエリ設定
      $scope.query = {
        order: 'engagements',
        limit: 25,
        options: [10, 25, 50],
        page: 1,
      }
      if ($scope.selectedTab === 'youtube') {
        $scope.query.order = 'views'
      } else if ($scope.selectedTab === 'tiktok') {
        $scope.query.order = 'plays'
      }
      $scope.dataPerPost = true

      // キーワード検索
      $rootScope.messageFilter = null
      // メインカテゴリ
      $scope.categoryName = null
      // サブカテゴリ
      $scope.subCategoryName = null

      // グローバルアカウントフラグ
      $scope.accountGlobalFilter = null

      // アカウントのデータ
      $scope.sortAccounts = []
      // フィルタリングで除外されたアカウント
      $scope.removedAccounts = []

      const privateFlg = $filter('filter')($rootScope.followerFilter, '非公開')

      // youtubeではない場合 and 非公開でフィルタリング中の場合、非公開条件を削除
      if ($scope.selectedTab !== 'youtube' && privateFlg !== null && privateFlg.length > 0) {
        $rootScope.followerFilter = $rootScope.followerFilter.filter((follower) => {
          return follower !== '非公開'
        })

        if ($rootScope.followerFilter.length === 0) {
          $rootScope.followerFilter = null
        }
      }
    }

    // 期間指定(デフォルトは1日前から31日間)
    const startEndDate = {
      startDate: moment(moment().subtract(31, 'days').format('YYYY-MM-DD 00:00:00')).unix(),
      endDate: moment(moment().subtract(1, 'days').format('YYYY-MM-DD 00:00:00')).unix(),
    }

    // ソートのイベント
    $scope.onReorder = function (order) {
      // ソート
      $scope.sortAccounts = AccountService.Account.orderBy(
        $scope.sortAccounts,
        order,
        $scope.dataPerPost
      )
      // ページングを初期化
      $scope.query.page = 1
    }

    // 対象日付の変更を検知して投稿一覧情報を描画
    $scope.$watch(
      () => {
        return $scope.startEndDate
      },
      () => {
        if ($scope.startEndDate !== undefined) {
          // date-range-pickerで期間を指定した場合、セット
          if ($scope.startDate !== undefined && $scope.endDate !== undefined) {
            startEndDate.startDate = $scope.startDate
            startEndDate.endDate = $scope.endDate
            $scope.selectedIds = []
            // 指定した期間にて、アカウント一覧を取得する
            getAccounts($rootScope.groupId, $rootScope.userId, $scope.categoryName, 1)
          }
        }
      }
    )

    // アカウント一覧のチェックボックスにチェックを入れた際の処理
    $scope.$on('addTargetId', (event, targetId: number) => {
      // チェックを入れた変更対象のIDを配列として保持する
      $scope.selectedIds.push(targetId)
    })

    // アカウント一覧のチェックボックスのチェックを外した際の処理
    $scope.$on('removeTargetId', (event, targetId: number) => {
      // IDを変更対象の配列から削除する
      const filterdArray: number[] = $scope.selectedIds.filter((element: number) => {
        return element !== targetId
      })
      $scope.selectedIds = filterdArray
    })

    // 選択のリセットボタンを押した際の処理
    $scope.$on('resetAllSelectedIds', () => {
      // 選択中のIDの配列を全て空にする
      $scope.selectedIds = []
      $scope.$broadcast('resetCheckBox')
    })

    // テーブルをリロードする
    $scope.$on('reloadTable', () => {
      // アカウント一覧を再取得する
      getAccounts($rootScope.groupId, $rootScope.userId, $scope.categoryName, $scope.query.page)
    })

    /**
     * getAccounts 全アカウントのデータを取得
     * @param  groupId グループID
     * @param  userId ユーザーID
     * @param  selectedMonth 選択した期間
     * @param  categoryName カテゴリ名
     * @param  pageNum ページ番号
     * @return {void}
     */
    function getAccounts(groupId: number, userId: number, categoryName: string, pageNum: number) {
      $scope.isLoading = true

      $scope.getOptions = {
        startEndDate: startEndDate,
        categoryName: categoryName,
        isPro: $rootScope.isPro,
      }

      AccountService.Account.getAccounts(
        groupId,
        userId,
        $scope.selectedTab,
        $scope.getOptions
      ).then((accounts) => {
        // アカウントのデータをセットしてスコープに保存
        const sortAccounts = AccountService.Account.setAccounts($scope.selectedTab, accounts)
        // ソート
        $scope.sortAccounts = AccountService.Account.orderBy(
          sortAccounts,
          $scope.query.order,
          $scope.dataPerPost
        )
        // フィルタリングで除外されたアカウントを空欄でセットする
        $scope.removedAccounts = []

        // フィルタリングを行う
        changeFilter()

        // ページングを初期化
        $scope.query.page = pageNum

        // 取得が完了したら、ロード中フラグを下げる
        $scope.isLoading = false
      })
    }

    // brandCategoryFormディレクティブから、'changeBrandCategory'を受信した場合
    $scope.$on(
      'changeBrandCategory',
      (
        event,
        categoryInfo: {
          type: string
          categoryName: string
          subCategoryName: string
        }
      ) => {
        if (categoryInfo.type !== 'account') {
          return
        }
        // 選択したメインカテゴリ、サブカテゴリをセット
        $scope.categoryName = null
        $scope.subCategoryName = null

        // メインカテゴリがある場合、スコープへカテゴリ、サブカテゴリを格納
        if (categoryInfo !== null) {
          $scope.categoryName = categoryInfo.categoryName
          $scope.subCategoryName =
            categoryInfo.subCategoryName !== '指定しない' ? categoryInfo.subCategoryName : null
        }
        // 指定した業種にて、アカウント一覧を取得する
        if ($rootScope.groupId !== undefined) {
          $scope.selectedIds = []
          getAccounts($rootScope.groupId, $rootScope.userId, $scope.categoryName, 1)
        } else {
          // グループID、ユーザーIDが未取得の場合は、0.2秒待って、再度全投稿を取得する
          $timeout(() => {
            getAccounts($rootScope.groupId, $rootScope.userId, $scope.categoryName, 1)
          }, 200)
        }
      }
    )

    // ディレクティブから、'changeFilterData'を受信した場合
    $scope.$on(
      'changeFilterData',
      (event, filterInfo: { type: string; value: string; subCategoryType?: string }) => {
        switch (filterInfo.type) {
          // サブカテゴリのフィルタリング
          case 'subCategoryFilter':
            // アカウントのサブカテゴリではない場合は、リターン
            if (filterInfo.subCategoryType !== 'account') {
              return
            }
            $scope.subCategoryName = filterInfo.value
            break
        }

        // フィルタリングを行う
        changeFilter()
      }
    )

    /**
     * フォロワー数範囲の変更イベント
     * @param {string[]} followerRange フォロワー数範囲
     */
    $scope.changeFollowerFilter = (followerRange: string[]) => {
      if ($rootScope.followerFilter === followerRange) {
        return
      }
      $rootScope.followerFilter = followerRange
      // フィルターを変更する
      changeFilter()
    }

    /**
     * アカウントグローバルの変更イベント
     * @param {number} accountGlobal アカウントグローバル
     */
    $scope.changeAccountGlobalFilter = (accountGlobal: number) => {
      if ($scope.accountGlobalFilter === accountGlobal) {
        return
      }
      $scope.accountGlobalFilter = accountGlobal
      // フィルターを変更する
      changeFilter()
    }

    /**
     * キーワードの変更イベント
     * @param {string} keyword キーワード
     */
    $scope.changeKeywordFilter = (keyword: string) => {
      if ($rootScope.messageFilter === keyword) {
        return
      }
      $rootScope.messageFilter = keyword
      // フィルターを変更する
      changeFilter()
    }

    /**
     * アカウントタグの変更イベント
     * @param {string[]} selectedTags 選択したタグリスト
     */
    $scope.changeSelectedAccountTags = (selectedTags: string[]) => {
      $rootScope.accountTagFilter = selectedTags
      // フィルターを変更する
      changeFilter()
    }

    // 一覧のタグがクリックされた場合、フィルタリングを行う
    $scope.$on('clickAccountTableTag', (event: any, tagName: string) => {
      if ($rootScope.accountTagFilter && $rootScope.accountTagFilter.length > 0) {
        $rootScope.accountTagFilter.push(tagName)
      } else {
        $rootScope.accountTagFilter = [tagName]
      }
      // フィルターを変更する
      changeFilter()
    })

    /**
     * フィルターの変更
     */
    function changeFilter() {
      // アカウントをフィルタリング
      filterAccount(
        $scope.subCategoryName,
        $scope.accountGlobalFilter >= 0 ? $scope.accountGlobalFilter : null,
        $scope.sortAccounts,
        $scope.removedAccounts
      )
    }

    /**
     * アカウントをフィルタリング
     * @param {string} subCategoryName サブカテゴリ
     * @param {string} accountGlobalFilter グローバルアカウントフラグ
     * @param {array} sortAccounts アカウントのデータ
     * @param {array} removedAccounts フィルタリングで除外されたアカウント
     * @return {void}
     */
    function filterAccount(
      subCategoryName: string,
      accountGlobalFilter: string,
      sortAccounts: string[],
      removedAccounts: string[]
    ) {
      $scope.isLoading = true
      // 条件を指定してアカウント一覧をフィルタリングする
      AccountService.Filtering.filterAccount(
        subCategoryName,
        accountGlobalFilter,
        sortAccounts,
        removedAccounts
      ).then((result) => {
        // フィルタリングに適合したアカウントを一覧に表示する
        $scope.sortAccounts = AccountService.Account.orderBy(
          result.sortAccounts,
          $scope.query.order,
          $scope.dataPerPost
        )
        // フィルタリングで不適合のアカウントは一覧に表示せず、scopeに保持する
        $scope.removedAccounts = result.removedAccounts
        // ページングを初期化
        $scope.query.page = 1
        // 選択中のアカウント一覧を解除
        $scope.selectedIds = []
        // ロードフラグを解除
        $scope.isLoading = false
      })
    }

    /**
     * resetPanigation ソートしたらページングを1に戻す
     * @return {void}
     */
    $scope.resetPanigation = function (dataPerPost) {
      $scope.dataPerPost = dataPerPost
    }

    /**
     * onPaginate ページングを移動するイベント
     * @return {void}
     */
    $scope.onPaginate = function () {
      angular.element('body').scrollTop(130)
      $scope.$broadcast('onPaginate')
    }
  }
)
